const types = {
    album: 'album',
    artist: 'artist',
    audioClip: 'audioClip',
    category: 'category',
    container: 'container',
    link: 'link',
    program: 'program',
    prompt: 'prompt',
    station: 'station',
    topic: 'topic',
    user: 'user',
};
const guideIdPrefixTypeMap = {
    a: types.category,
    c: types.category,
    d: types.album,
    g: types.category,
    i: types.audioClip,
    m: types.artist,
    p: types.program,
    r: types.category,
    s: types.station,
    t: types.topic,
    u: types.user,
};
const guideIdUtils = {
    sanitize(guideId) {
        return !guideId || guideId === 'o0' ? null : guideId;
    },
    types: types,
    guideIdPrefixTypeMap: guideIdPrefixTypeMap,
    getType(guideId) {
        return guideId ? this.guideIdPrefixTypeMap[guideId[0]] : null;
    },
    extractTypedGuideIds(guideId, container) {
        const guideIdType = this.getType(guideId);
        const ret = container || {};
        if (guideId && guideIdType) {
            ret[`${guideIdType}Id`] = guideId;
            return ret;
        }
        return ret;
    },
};
export default guideIdUtils;
